import { render, staticRenderFns } from "./CreateDamageTemplate.vue?vue&type=template&id=37d4456a"
import script from "./CreateDamageTemplate.vue?vue&type=script&lang=js"
export * from "./CreateDamageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports